import { catchError, firstValueFrom, Observable, take, throwError } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { ResponseActiveServices, UserActiveSubscriptionsResponse } from './api.model';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private readonly http = inject(HttpClient);

  private apiUrl = environment.apiUrl;

  getServicesActive(): Promise<ResponseActiveServices> {
    return firstValueFrom(
      this.http.get<ResponseActiveServices>(`${this.apiUrl}/v1/services/active`).pipe(
        take(1),
        catchError(this.handleError)
      )
    );
  }

  getUsersActiveSubscriptions(): Promise<UserActiveSubscriptionsResponse> {
    return firstValueFrom(
      this.http.get<UserActiveSubscriptionsResponse>(`${this.apiUrl}/v1/user/active_subscriptions`).pipe(
        take(1),
        catchError(this.handleError)
      )
    );
  }

  private handleError(error: unknown): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => error);
  }
}
